import * as React from 'react'
import axios from 'axios'

import { Button, TYPES } from './../shared/button'
import {createCostAnalysisPdf} from './../shared/utils'
import './../../styles/admin/costAnalysis.css'
import logo from './../../images/logo.png'

axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

class CostAnalysisResults extends React.Component {
  constructor () {
    super()

    this.state = {
      minutesSaved: '--',
      currentExpense: null,
      baywatchCost: null,
      carsPerDay: null,
      percentSaved: '--',
      lifetimeValue: '--'
    }
  }

  minutesSaved = (carsPerDay) => {
    const minutesSaved = carsPerDay * 2
    this.setState({minutesSaved: minutesSaved, carsPerDay: carsPerDay})
  }

  savingsPercent = () => {
    const currentExpense = parseInt(this.state.currentExpense, 10)
    const baywatchCost = parseInt(this.state.baywatchCost, 10)
    if(baywatchCost && currentExpense) {
      const amountSaved = currentExpense - baywatchCost
      const percentSaved = Math.round((amountSaved / currentExpense) * 100)
      if(percentSaved < 0) {
        this.setState({percentSaved: '--'})
        return percentSaved
      }
      this.setState({percentSaved: percentSaved})
      return percentSaved
    } else {
      this.setState({percentSaved: '--'})
    }
  }

  submitCostAnalysisForm = (event) => {
    event.preventDefault()
    const currentExpense = document.getElementById("currentExpense").value
    const lifetimeValue = document.getElementById("lifetimeValue").value
    const baywatchCost = document.getElementById("baywatchCost").value
    const percentSaved = String(this.state.percentSaved)
    const minutesSaved = String(this.state.minutesSaved)
    const carsPerDay = document.getElementById("carsPerDay").value
    const email= document.getElementById("email").value

    let payload = {
      email: email,
      current_expense: parseInt(currentExpense, 10),
      customer_value: parseInt(lifetimeValue, 10),
      baywatch_cost: parseInt(baywatchCost, 10),
      cars_per_day: parseInt(carsPerDay, 10),
    }
    axios.post('/api/cost_analysis.json', payload,       {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      createCostAnalysisPdf(currentExpense, lifetimeValue, baywatchCost, percentSaved, carsPerDay, minutesSaved)
    }).catch(error => {
      alert('Error')
    })
  }

  render() {
    return (
      <div className='cost-analysis-box'>
        <img src={logo} alt='BayWatch Technologies' />
        <form className='cost-analysis-form'
          onSubmit={this.submitCostAnalysisForm}>
          <div className='form-section'>
            <div className='form-inner-section'>
              <h3>Save Money</h3>
              <p>The return on investment of a BayWatch system is unique to each dealership, but it is safe to say that your savings will add up to thousands of dollars very quickly. Get policy expense savings right away and stop paying on false damage claims!</p>
              <div className='form-container'>
                <div>
                  <label>How much do you spend on damage claims every month? </label>
                  <input onChange={(event) => this.setState({currentExpense: event.target.value}, () => this.savingsPercent())} id='currentExpense' required className='cost-analysis-input'/>
                </div>
                <div>
                  <label>How much does your BayWatch System cost? </label>
                  <input onChange={(event) => this.setState({baywatchCost: event.target.value}, () => this.savingsPercent())} id='baywatchCost' required className='cost-analysis-input'/>
                </div>
              </div>
            </div>
            <div>
              <div className='detail-box-content'>
                  <label>Up to </label>
                  <p> {this.state.percentSaved}% </p>
                  <label>Saved</label>
              </div>
            </div>
          </div>
          <div className='form-section'>
            <div className='form-inner-section'>
              <h3>Increase Customer Satifaction</h3>
              <p>Our system will increase your positive customer reviews and reduce negative social media reviews. One negative review can cost up to 30 new customers, while it takes 12 positive reviews to cancel out one negative.</p>
              <p>Why make your customer guilty until proven innocent? With BayWatch there will be no arguments, no hassle, no accusations. It is proven that independent dispute resolution improves customer satisfaction and retention, while also empowering service advisors and managers.</p>
              <p>One customer saved will cover your BayWatch investment for more than one year.</p>
              <div>What is the lifetime dollar value of a customer at your dealership?</div>
               <input id='lifetimeValue' className='cost-analysis-input' onChange={(event) =>  this.setState({lifetimeValue: event.target.value})}/>
            </div>
            <div>
              <div className='detail-box-content'>
              <label>Lifetime value </label>
              <p> ${this.state.lifetimeValue} </p>
              <label>of a customer</label>
              </div>
            </div>
          </div>
          <div className='form-section'>
            <div className='form-inner-section'>
              <h3>Save Time</h3>
              <p>Automation eliminates human error, captures 100% of vehicles, and saves time. Save up to two minutes for each vehicle check in.</p>
              <div>
                <label>How many cars drive into your service center each day?</label>
                <input onChange={(event) => this.minutesSaved(event.target.value)} id='carsPerDay' required className='cost-analysis-input'/>
              </div>
            </div>
            <div>
              <div className='detail-box-content'>
                  <p id='minutesSaved'>{this.state.minutesSaved}</p>
                  <label>Minutes Saved</label>
              </div>
            </div>
          </div>
          <div className='download-pdf'>
            <input type='email' id='email' required className='cost-analysis-input' placeholder='Email'/>
            <Button
              text='Download PDF'
              type='viewNote'
              buttonType={TYPES.SUBMIT}
            />
          </div>
        </form>
      </div>
    )
  }
}

export default CostAnalysisResults



// WEBPACK FOOTER //
// ./src/components/admin/costAnalysisResults.js